import type { ModuleID, VersionString, ViewID } from "@bestowinc/tinkertoy-core";

/** Log `tag` values for Tinkertoy V2 client failure telemetry. */
export const FAILURE_EVENT_TAGS = {
  shellLoader: "tinkertoy.shell_loader_failure",
  shellBoundary: "tinkertoy.shell_error_boundary",
  viewBundleLoad: "tinkertoy.view_bundle_load_failure",
  moduleBundleLoad: "tinkertoy.module_bundle_load_failure",
  moduleAction: "tinkertoy.module_action_failure",
  viewInteraction: "tinkertoy.view_interaction_failure",
  errorViewLoad: "tinkertoy.error_view_load_failure",
  loadingModuleLoad: "tinkertoy.loading_module_load_failure",
  loadingModuleRender: "tinkertoy.loading_module_render_failure",
} as const;

export type FailureEventTag =
  (typeof FAILURE_EVENT_TAGS)[keyof typeof FAILURE_EVENT_TAGS];

/**
 * Safe, low-cardinality attributes attached to every Tinkertoy V2 failure record.
 * Omit payloads, props, view data, tokens, email, raw query strings, and URLs.
 */
export type FailureAttributes = {
  tag: FailureEventTag;
  errorCode: string;
  shellVersion?: string;
  flowId?: string;
  branchId?: string;
  viewId?: ViewID;
  viewVersion?: VersionString;
  moduleId?: ModuleID;
  moduleVersion?: VersionString;
  actionScope?: "module" | "view_interaction";
  actionName?: string;
};

export type ReportFailureArgs = {
  tag: FailureEventTag;
  errorCode: string;
  message: string;
  error: Error;
  shellVersion?: string;
  flowId?: string;
  branchId?: string;
  viewId?: ViewID;
  viewVersion?: VersionString;
  moduleId?: ModuleID;
  moduleVersion?: VersionString;
  actionScope?: "module" | "view_interaction";
  actionName?: string;
};
